module.exports = __webpack_public_path__ + "static/avatar-bcf9c035367bdd7cac4ed81104c55fb2.jpg";